export default __webpack_public_path__ + "static/media/sonia-modal.3dfd1c7e.jpg";